import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: ${props => props.theme.alignItems};
  justify-content: space-between;
  flex-wrap: wrap;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  border-radius: ${props => props.theme.borderRadius.default};

  ${props =>
    props.theme.isBackground &&
    css`
      background: ${props => props.titleBackground || props.theme.background};
    `}

  ${props =>
    props.theme.borderBottom &&
    css`
      border-bottom: ${props => props.theme.borderBottom};
    `}
  }  
    
  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;

export const Text = styled.h1`
  display: block;
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  color: ${props => props.titleColor || props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  z-index: 0;
  cursor: default;
  text-transform: ${props => props.theme.textTransform || 'none'};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;
export const Subtext = styled.p`
  display: block;
  align-self: flex-end;
  padding: ${props => props.theme.paddingDefault || '0'};
  transition: 0.2s all;
  color: ${props => props.titleColor || props.theme.color || 'inherit'};
  font-family: ${props => props.theme.fontFamily || 'inherit'};
  font-size: ${props => `${props.theme.fontSize}rem` || 'inherit'};
  line-height: ${props => props.theme.lineHeight || 'inherit'};
  font-weight: ${props => props.theme.fontWeight || 'inherit'};
  text-transform: ${props => props.theme.textTransform || 'none'};
  cursor: default;
  ${Media.md`
    padding: ${props => props.theme.paddingMd || 'inherit'};
  `}
`;
export const Link = styled(RouterLink)`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  border-radius: ${props => props.theme.borderRadius.default};
   ${props =>
     props.theme.background &&
     css`
       background: ${props => props.linkBackground || props.theme.background};
     `}
    ${props =>
      props.theme.color &&
      css`
        color: ${props => props.linkColor || props.theme.color};
      `}
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  white-space: nowrap;
  z-index: 0;
  cursor: pointer;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    border-radius: ${props => props.theme.borderRadius.sm};
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:hover {
    color: ${props => props.theme.colorOnHover};
  }

  ${props =>
    props.theme.triangleShape &&
    css`
      &::after {
        position: absolute;
        top: ${props.theme.triangleShape.top};
        right: ${props.theme.triangleShape.right};
        bottom: ${props.theme.triangleShape.bottom};
        left: ${props.theme.triangleShape.left};
        width: ${props.theme.triangleShape.width};
        height: ${props.theme.triangleShape.height};
        transition: 0.2s all;
        clip-path: ${props.theme.triangleShape.clipPath};
        /* background: ${props.theme.triangleShape.background}; */
        ${props =>
          props.theme.triangleShape.background &&
          css`
            background: ${props =>
              props.linkBackground || props.theme.triangleShape.background};
          `}
        content: '';
      }
    `}
`;

export const Arrow = styled.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: ${props => props.theme.margin.default};
  min-width: ${props => props.theme.minWidth};
  min-height: ${props => props.theme.minHeight};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  vertical-align: middle;
  border-radius: ${props => props.theme.borderRadius.default};
  transition: .2s all;

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${props =>
    props.theme.invert &&
    css`
      background: ${props => props.theme.color};
      color: ${props => props.theme.background};
    `}

  ${Link}:hover & {
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};

    ${props =>
      props.theme.invert &&
      css`
        background: ${props => props.theme.colorOnHover};
        color: ${props => props.theme.backgroundOnHover};
      `}
  }
`;
